/**
 * The outlined pill a listing uses for an action or a filter chip.
 *
 * <p>Exported because two places draw it: `TableActionButton` (the Review button in an Action
 * column) and the filter chip row. They were written separately and had drifted -- the button was
 * a hardcoded `15px`, the chip `1.5rem` -- so the two pills in the same table were different
 * shapes, and the button stopped scaling once the console re-bases its root font at wider
 * viewports.
 *
 * <p>Design px against the app's 12px root: 15 / 12.
 */
export const LISTING_PILL_RADIUS = '1.25rem';
